import FilterDropdown from "./FilterDropdown";
import type { CourseFilterConfig } from "@/features/universityAndCourse/hooks/useCourseFilters";
import { cn } from "@/lib/utils";

function searchPlaceholderForKey(key: string): string {
  const m: Record<string, string> = {
    country: "Search countries…",
    university: "Search universities…",
    courseType: "Search course types…",
    match: "Search match…",
    level: "Search levels…",
  };
  return m[key] ?? "Search options…";
}

interface FilterSectionProps {
  configs: CourseFilterConfig[];
  filters: Record<string, string>;
  onFilterChange: (key: string, value: string) => void;
  className?: string;
}

// Column count follows the number of filters so two filters share the row
// instead of sitting in the first two of five slots.
const GRID_COLS_BY_COUNT: Record<number, string> = {
  1: "sm:grid-cols-1",
  2: "sm:grid-cols-2",
  3: "sm:grid-cols-2 lg:grid-cols-3",
  4: "sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
};
const GRID_COLS_MAX =
  "sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5";

export default function FilterSection({
  configs,
  filters,
  onFilterChange,
  className,
}: FilterSectionProps) {
  return (
    <div
      className={cn(
        "grid w-full grid-cols-1 gap-x-3 gap-y-4",
        GRID_COLS_BY_COUNT[configs.length] ?? GRID_COLS_MAX,
        className,
      )}
    >
      {configs.map((config) => (
        <div key={config.key} className="flex min-w-0 flex-col gap-1.5">
          <span
            id={`course-filter-label-${config.key}`}
            className="text-[12px] leading-tight font-medium text-[var(--color-text-secondary)]"
          >
            {config.label}
          </span>
          <FilterDropdown
            aria-labelledby={`course-filter-label-${config.key}`}
            value={filters[config.key] ?? "all"}
            onValueChange={(value) => onFilterChange(config.key, value)}
            options={config.options}
            searchInputPlaceholder={searchPlaceholderForKey(config.key)}
          />
        </div>
      ))}
    </div>
  );
}
